import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import LazyRoute from '../components/LazyRoute'
import { TablePageLoader } from '@/components/ui/page-loader'

const searchSchema = z.object({
  source_id: z.string().optional(),
})

export const Route = createFileRoute('/_protected/events/incoming')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/pages/EventsIncoming')}
      fallback={<TablePageLoader />}
    />
  ),
  validateSearch: searchSchema,
})
